import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { useReportBottomBannerHeight } from '../hooks/useReportBottomBannerHeight';

interface BudgetPauseBannerProps {
  estimatedSpendSgd: number;
  limitSgd: number;
  onOpenSettings: () => void;
}

/** Fixed bottom banner when Official API daily budget is hit / about to hit. */
export default function BudgetPauseBanner({
  estimatedSpendSgd,
  limitSgd,
  onOpenSettings,
}: BudgetPauseBannerProps) {
  const ref = useReportBottomBannerHeight(12);

  return (
    <Box
      ref={ref}
      sx={{
        position: 'fixed', left: 4, right: 4, bottom: 4, zIndex: (t) => t.zIndex.appBar + 1,
        bgcolor: '#7c2d12',
        color: '#ffffff',
        border: '2px solid #fb923c',
        borderRadius: 1.5,
        boxSizing: 'border-box',
        px: { xs: 2, md: 3 }, py: 1.25,
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5, flexWrap: 'wrap',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, minWidth: 0, flex: '1 1 220px' }}>
        <WarningAmberOutlinedIcon sx={{ color: '#fdba74', flexShrink: 0, mt: 0.2 }} />
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="body2" sx={{ color: '#fff !important', fontWeight: 700, lineHeight: 1.45 }}>
            Official API sends are paused — today’s estimate (S${estimatedSpendSgd.toFixed(2)}) would exceed your
            daily budget of S${limitSgd.toFixed(2)}.
          </Typography>
          <Typography variant="caption" sx={{ color: '#fed7aa !important', display: 'block', mt: 0.25 }}>
            Raise or clear the budget under Integrations to resume automated campaigns.
          </Typography>
        </Box>
      </Box>
      <Button
        variant="contained"
        size="small"
        onClick={onOpenSettings}
        sx={{
          bgcolor: '#ed8936',
          color: '#111827 !important',
          '&:hover': { bgcolor: '#f59e52' },
          textTransform: 'none',
          fontWeight: 800,
          flexShrink: 0,
        }}
      >
        Open Integrations
      </Button>
    </Box>
  );
}
